import React, {
  useEffect,
} from 'react';
import compact from 'lodash/compact';
import {
  useMedia,
} from 'core/hooks';
import {
  MediaOriginatorType,
} from 'pages/Dashboard/utils/constants';
import {
  MoveToCreditLogViewModel,
} from 'dtos';
import {
  useGetMoveToCreditLogs,
} from 'views/EMR/hooks/billing';
import Table from 'core/components/VirtualTable';
import moveToCreditLogsColumns from 'views/EMR/Billing/AdjustPayment/MoveToCreditLogsColumns';
import {
  ColumnDef,
} from '@tanstack/react-table';
import isNil from 'lodash/isNil';

type Props = {
  patientId: number;
  maxHeight: number | null;
};

export default function MoveToCreditLogs({
  patientId,
  maxHeight,
}: Props) {
  const { data, isLoading } = useGetMoveToCreditLogs(patientId);
  const { requestMedia } = useMedia();

  useEffect(() => {
    if (!isNil(data)) {
      const userIds = compact(data.map(({ movedByUserId }) => movedByUserId));
      if (userIds.length > 0) {
        requestMedia(userIds, MediaOriginatorType.User);
      }
    }
  }, [data, requestMedia]);

  return (
    <div className="flex relative w-full !overflow-auto p-4" style={{ maxHeight: `${maxHeight}px` }}>
      <div className="flex flex-1 flex-col w-full move-to-credit-table">
        <Table<MoveToCreditLogViewModel>
          columns={moveToCreditLogsColumns as ColumnDef<MoveToCreditLogViewModel>[]}
          data={data ?? []}
          emptySlot="No move to credit history found."
          skeleton={{ rows: 3 }}
          loading={isLoading}
          classes={{
            body: '!m-0 !p-0 !bg-white',
            scrollContainer: '!p-0',
            column: '!text-left',
            outerHeader: '!bg-gray-100 !border !border-gray-200 !rounded-sm',
            header: '!text-gray-700 !py-2 !border-0',
            scrollbarGutter: 'inherit',
            windowsClassName: '!w-full',
          }}
        />
      </div>
    </div>
  );
}
